import { Formik, Form, ErrorMessage } from "formik";
import CustomField from "./CustomField";

const FormComponent = ({fields,validationSchema,initialValues,onSubmit,onCancel,buttonText = "Submit",secondbtn = "Cancel"}) => (
  <Formik initialValues={initialValues} validationSchema={validationSchema}  onSubmit={onSubmit} >
    {({ setFieldValue, values, isSubmitting, touched, errors }) => (

      <Form className="space-y-6 bg-white p-4 rounded-lg ">

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3.2">
          
          {fields.map((field, index) => (
            <div key={index} className="space-y-2">
              <div>
                <label htmlFor={field.name} className="block text-sm font-medium text-gray-700" style={{ visibility: field.hidden ? "hidden" : "visible" }}  >
                {field.label} {field?.required ? ( <span className="text-red-700 text-md">*</span>) : ("")}
                </label>
                <CustomField field={field} setFieldValue={setFieldValue} values={values} />
                {field.type == "finger" ? (errors.finger_data && touched.finger_data ? (<div class="text-red-500 !mt-1.5 text-base"> Fingerprint is required </div>) : ("")) : ("" )}
                {field.type == "finger" ? ("") : (<ErrorMessage name={field.name} component="div" className="text-red-500 !mt-1.5 text-base" />)}
              </div>
            </div>
          ))}
        </div>

        <div className="flex justify-end space-x-4">
          {secondbtn && (<button  type="button" className="px-4 py-2 text-white bg-gray-400 rounded-lg" onClick={onCancel}> {secondbtn} </button> )}
          <button type="submit" className="px-4 py-2 bg-secondary text-white rounded-lg"  disabled={isSubmitting} > {buttonText} </button>
        </div>
      </Form>
    )}
  </Formik>
);

export default FormComponent;